"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMainFrameNavigator = exports.MainFrameNavigator = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/searchable-tree-menu/lib-es2015");
class MainFrameNavigator extends HTMLElement {
    constructor() {
        super();
        this.router = (0, lib_es2015_1.useRouter)();
        const isMobile = window.matchMedia(`(max-width: 600px)`).matches;
        const menuCfg = {
            name: ``,
            children: [],
            isFold: false,
        };
        const treeMenu = new lib_es2015_2.MenuNode(menuCfg, 0);
        this.appendChild(treeMenu);
        if (isMobile)
            this.style.setProperty('display', 'none');
    }
}
exports.MainFrameNavigator = MainFrameNavigator;
const defineMainFrameNavigator = (name) => {
    (0, lib_es2015_2.define)(`searchable-tree-menu`);
    (0, lib_es2015_1.defineIfUndefined)(name, MainFrameNavigator);
};
exports.defineMainFrameNavigator = defineMainFrameNavigator;
